import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-add-company',
  template: `
    <p>
      modal-add-company works!
    </p>
  `,
  styles: ``
})
export class ModalAddCompanyComponent {

}
